import {
    getCachedTableDataSlice,
    getCachedTableResultSelector,
} from 'src/hooks/common-data-service/cached-table';
import {ResourceView} from 'src/modules/entitlements/typedef';

import {rolesGrantsResourcesStateSelector} from './roles-grants-resources-state.slice';

import type {RolesGrantsResourcesFilters} from '../typedef';
import type {CachedTableCacheSelector, CachedTableDataSelector} from 'src/hooks/common-data-service/cached-table/typedef';


export const rolesGrantsResourcesSlice = getCachedTableDataSlice<
    ResourceView[],
    undefined,
    undefined,
    RolesGrantsResourcesFilters
>('rolesGrantsResources');

export const rolesGrantsResourcesActions = rolesGrantsResourcesSlice.actions;
const rolesGrantsResourcesCacheSelector: CachedTableCacheSelector<ResourceView[]>
    = state => state.manageEntitlements.rolesGrantsResourcesReducer.rolesGrantsResources.cache;
export const rolesGrantsResourcesDataSelector: CachedTableDataSelector<ResourceView[]>
    = state => state.manageEntitlements.rolesGrantsResourcesReducer.rolesGrantsResources;
export const rolesGrantsResourcesResultSelector = getCachedTableResultSelector(
    rolesGrantsResourcesCacheSelector,
    rolesGrantsResourcesStateSelector,
);
